export default __webpack_public_path__ + "static/Decorative Category-18a6d4a738203f5b306652917d45e245.webp";